export interface IAppError {
  type?: string;
  message?: string;
  details?: string[];
}

export class AppError extends Error {
  public type: string;
  public message: string;
  public details: string[];
  public isAppError: boolean;

  public constructor(settings: IAppError = {}) {
    super();

    this.name = 'AppError';

    this.type = settings.type || 'Application';
    this.message = settings.message || 'An error occurred.';
    this.details = settings.details || [];

    this.isAppError = true;

    Error.captureStackTrace(this, AppError);
  }
}
